import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/img/img.jpg';

var _withId = /*#__PURE__*/_withScopeId("data-v-16af0e60");

_pushScopeId("data-v-16af0e60");

var _hoisted_1 = {
  class: "header"
};
var _hoisted_2 = {
  key: 0,
  class: "el-icon-s-fold"
};
var _hoisted_3 = {
  key: 1,
  class: "el-icon-s-unfold"
};
var _hoisted_4 = {
  class: "logo"
};
var _hoisted_5 = {
  class: "header-right"
};
var _hoisted_6 = {
  class: "header-user-con"
};

var _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "user-avator"
}, [/*#__PURE__*/_createVNode("img", {
  src: _imports_0
})], -1);

var _hoisted_8 = {
  class: "el-dropdown-link"
};

var _hoisted_9 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-caret-bottom"
}, null, -1);

var _hoisted_10 = /*#__PURE__*/_createTextVNode("退出登录");

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache) {
  var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  var _component_el_dropdown = _resolveComponent("el-dropdown");

  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode("div", {
    class: "collapse-btn",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.collapseChage && _ctx.collapseChage.apply(_ctx, arguments);
    })
  }, [!_ctx.collapse ? (_openBlock(), _createBlock("i", _hoisted_2)) : (_openBlock(), _createBlock("i", _hoisted_3))]), _createVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1), _createVNode("div", _hoisted_5, [_createVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_dropdown, {
    class: "user-name",
    trigger: "click",
    onCommand: _ctx.handleCommand
  }, {
    dropdown: _withId(function () {
      return [_createVNode(_component_el_dropdown_menu, null, {
        default: _withId(function () {
          return [_createVNode(_component_el_dropdown_item, {
            divided: "",
            command: "loginout"
          }, {
            default: _withId(function () {
              return [_hoisted_10];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    default: _withId(function () {
      return [_createVNode("span", _hoisted_8, [_createTextVNode(_toDisplayString(_ctx.username) + " ", 1), _hoisted_9])];
    }),
    _: 1
  }, 8, ["onCommand"])])])]);
});